import { render, staticRenderFns } from "./VolunteerForm.vue?vue&type=template&id=524a28e6&scoped=true&"
import script from "./VolunteerForm.vue?vue&type=script&lang=js&"
export * from "./VolunteerForm.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerForm.vue?vue&type=style&index=0&id=524a28e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a28e6",
  null
  
)

export default component.exports